<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :vendedores="enableVendedores"
                :redes="enableRedes"
                :meses="enableMeses"
                :anos="enableAnos"
                :supervisores="enableSupervisores"
                :btn1="enableBtn"
              />
            </v-col>
          </v-row>
          <v-row id="linhaAnaliseRedesFitrosId">
            <v-col
              cols="12"
              sm="2"
              md="2"
              lg="2"
            >
              <v-row v-if="enableBtnPrint">
                <v-btn
                  id="btnPrint"
                  class="col-12 col-sm-12 col-md-12 col-lg-12"
                  small
                  :color="corPrimaria"
                  dark
                  :loading="imprimindo"
                  @click="imprimir()"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                  Imprimir
                  <template v-slot:loader>
                    <span>Imprimindo...</span>
                  </template>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="bloco1Print">
            <v-col
              cols="12"
              sm="3"
              md="3"
              lg="3"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'312'"
                    :text="'Faturamento - R$'"
                    :texto-information="textoFat"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorFaturamento"
                    :padding="dynamicPaddingAnaliseVendaRedes1"
                    :loading="loadingFaturamento"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :exibir-informacao="false"
                    :text="'KG Total Faturamento'"
                    :style-object="styleObject"
                    :componente-valor="true"
                    :valor="valorKilos"
                    :padding="dynamicPaddingAnaliseVendaRedes4"
                    :loading="loadingKilos"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="9"
              md="9"
              lg="9"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'313'"
                :text="'Faturamento por Rede - R$'"
                :texto-information="textoFaturamentoPorRede"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoRedes'"
                :dados-grafico="chartBarFaturamentoRedes"
                :titulo-id="'myChartFaturamentoRedes'"
                :legenda-grafico="legendaGraficoFaturamentoRedes"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseVendaRedes2"
                :loading="loadingFaturamentoRedes"
              />
            </v-col>
          </v-row>
          <v-row id="bloco2Print">
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'314'"
                :text="'Comparativo Faturamento Anterior - KG'"
                :texto-information="textoQuantidadeKG"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoRedesKg'"
                :dados-grafico="chartBarFaturamentoRedesKg"
                :titulo-id="'myChartFaturamentoRedesKg'"
                :legenda-grafico="legendaGraficoFaturamentoRedesKg"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseVendaRedes3"
                :loading="loadingFaturamentoRedesKg"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'315'"
                :text="'Comparativo Faturamento Anterior - R$'"
                :texto-information="textoFatRS"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoRedesRS'"
                :dados-grafico="chartBarFaturamentoRedesRS"
                :titulo-id="'myChartFaturamentoRedesRS'"
                :legenda-grafico="legendaGraficoFaturamentoRedesRS"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseVendaRedes3"
                :loading="loadingFaturamentoRedesRS"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardAnaliseEquipeVendas',
    emits: ['setUpdateFiltros', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../components/core/FiltrosSaborDaSerra'),
      DashoardCardView: () => import('../../components/core/CardView'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleTexto: {
        color: '#00796B',
      },
      paginaEnable: false,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      redes: [],
      ano: [],
      mes: [],
      vendedor: [],
      supervisores: [],
      enableBtnPrint: false,
      permissaoAnaliseFaturamento: false,
      enableVendedores: false,
      enableRedes: true,
      enableMeses: true,
      enableAnos: true,
      enableBtn: true,
      enableSupervisores: true,
      codigo: 0,
      orientacao: [],
      textoFat: '',
      textoFaturamentoPorRede: '',
      textoQuantidadeKG: '',
      textoFatRS: '',
      codigoIds: ['312', '313', '314', '315'],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart: {},
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorKilos: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg',
      chartBarFaturamentoRedes: {},
      legendaGraficoFaturamentoRedes: [
        { status: 'Valor Faturamento', cor: '#4780b8' },
        { status: '% Valor Faturament', cor: '#ed934f' },
      ],
      chartBarFaturamentoRedesKg: {},
      legendaGraficoFaturamentoRedesKg: [
        { status: 'Quantidade Anterior', cor: '#cadaed' },
        { status: 'Quantidade Atual', cor: '#4780b8' },
      ],
      chartBarFaturamentoRedesRS: {},
      legendaGraficoFaturamentoRedesRS: [
        { status: 'Faturamento Anterior', cor: '#cadaed' },
        { status: 'Faturamento Atual', cor: '#4780b8' },
      ],
      dynamicPaddingAnaliseVendaRedes1: '',
      dynamicPaddingAnaliseVendaRedes2: '',
      dynamicPaddingAnaliseVendaRedes3: '',
      dynamicPaddingAnaliseVendaRedes4: '',
      loadingFaturamento: false,
      loadingKilos: false,
      loadingFaturamentoRedes: false,
      loadingFaturamentoRedesKg: false,
      loadingFaturamentoRedesRS: false,
      imprimindo: false,
    }),

    created () {
      eventEmit.$on('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$on('enable-btn-print', this.handleBtnPrint)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$off('enable-btn-print', this.handleBtnPrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Análise Redes')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseVendaRedes1 = 'padding-right: 16.5rem !important'

          this.dynamicPaddingAnaliseVendaRedes2 = 'padding-right: 80rem !important'

          this.dynamicPaddingAnaliseVendaRedes3 = 'padding-right: 42rem !important'

          this.dynamicPaddingAnaliseVendaRedes4 = 'padding-right: 18rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseVendaRedes1 = 'padding-right: 10.5rem !important'

          this.dynamicPaddingAnaliseVendaRedes2 = 'padding-right: 63rem !important'

          this.dynamicPaddingAnaliseVendaRedes3 = 'padding-right: 30rem !important'

          this.dynamicPaddingAnaliseVendaRedes4 = 'padding-right: 12rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseVendaRedes1 = 'padding-right: 8rem !important'

          this.dynamicPaddingAnaliseVendaRedes2 = 'padding-right: 8rem !important'

          this.dynamicPaddingAnaliseVendaRedes3 = 'padding-right: 8rem !important'

          this.dynamicPaddingAnaliseVendaRedes4 = 'padding-right: 8rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingAnaliseVendaRedes1 = 'padding-right: 9rem !important'

          this.dynamicPaddingAnaliseVendaRedes2 = 'padding-right: 20rem !important'

          this.dynamicPaddingAnaliseVendaRedes3 = 'padding-right: 20rem !important'

          this.dynamicPaddingAnaliseVendaRedes4 = 'padding-right: 20rem !important'
        } else {
          this.dynamicPaddingAnaliseVendaRedes1 = 'padding-right: 6.5rem !important'

          this.dynamicPaddingAnaliseVendaRedes2 = 'padding-right: 50rem !important;'

          this.dynamicPaddingAnaliseVendaRedes3 = 'padding-right: 22rem !important'

          this.dynamicPaddingAnaliseVendaRedes4 = 'padding-right: 8rem !important'
        }
      },

      handleUpdateDados (vendedor, redes, mes, ano, supervisores) {
        this.redes = redes
        this.mes = mes
        this.ano = ano
        this.supervisores = supervisores

        this.updateDate()
      },

      async updateDate () {
        eventEmit.$emit('set-update-filtros', this.redes, this.mes, this.ano, this.supervisores)

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorKilos = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'

        this.loadingFaturamento = true
        this.loadingKilos = true
        this.loadingFaturamentoRedes = true
        this.loadingFaturamentoRedesKg = true
        this.loadingFaturamentoRedesRS = true

        if (this.chartBarFaturamentoRedes.data) {
          this.chartBarFaturamentoRedes.destroy()
        }

        if (this.chartBarFaturamentoRedesKg.data) {
          this.chartBarFaturamentoRedesKg.destroy()
        }

        if (this.chartBarFaturamentoRedesRS.data) {
          this.chartBarFaturamentoRedesRS.destroy()
        }

        await Comercial.showFatRedes(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorFaturamento = 'R$' + resposta.data.faturamento.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            this.valorKilos = resposta.data.kilos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'
          } else if (resposta.data.text === 'Não há faturamento no período selecionado') {
            this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorKilos = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'

            this.showSnackbar('error', 3000, 'Não há faturamento no período selecionado')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingFaturamento = false; this.loadingKilos = false })

        await Comercial.showGraficoFaturamentoRedes(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChartFaturamentoRedes').getContext('2d')

            this.chartBarFaturamentoRedes = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                  {
                    label: 'Porcentagem',
                    data: resposta.data.faturamento,
                    type: 'line',
                    borderColor: '#ed934f',
                    backgroundColor: 'transparent',
                    order: 1,
                    fill: false,
                    tension: 0,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      if (tooltipItem.datasetIndex === 0) {
                        return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      } else {
                        return resposta.data.porcentagem[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
                      }
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - Faturamento'
                      } else {
                        return tooltipItem[0].xLabel + ' - Porcentagem'
                      }
                    },
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartBarFaturamentoRedes.data) {
              this.chartBarFaturamentoRedes.destroy()
            }

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartBarFaturamentoRedes.data) {
              this.chartBarFaturamentoRedes.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.chartBarFaturamentoRedes.data) {
              this.chartBarFaturamentoRedes.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoRedes = false })

        await Comercial.showGraficoFaturamentoRedesKg(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChartFaturamentoRedesKg').getContext('2d')

            this.chartBarFaturamentoRedesKg = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Quantidade Anterior',
                    data: resposta.data.kilosAnterior,
                    backgroundColor: '#cadaed',
                    order: 1,
                  },
                  {
                    label: 'Quantidade Atual',
                    data: resposta.data.kilos,
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      beginAtZero: true,
                      minRotation: 90, // Gira os rótulos
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                indexAxis: 'x',
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - Quantidade Anterior'
                      } else {
                        return tooltipItem[0].xLabel + ' - Quantidade Atual'
                      }
                    },
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartBarFaturamentoRedesKg.data) {
              this.chartBarFaturamentoRedesKg.destroy()
            }

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartBarFaturamentoRedesKg.data) {
              this.chartBarFaturamentoRedesKg.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingFaturamentoRedesKg = false })

        await Comercial.showGraficoFaturamentoRedesRS(this.redes, this.mes, this.ano, this.supervisores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChartFaturamentoRedesRS').getContext('2d')

            this.chartBarFaturamentoRedesRS = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento Anterior',
                    data: resposta.data.faturamentoAnterior,
                    backgroundColor: '#cadaed',
                    order: 1,
                  },
                  {
                    label: 'Faturamento Atual',
                    data: resposta.data.faturamento,
                    backgroundColor: '#4780b8',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    ticks: {
                      beginAtZero: true,
                      minRotation: 90, // Gira os rótulos
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                indexAxis: 'x',
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - Faturamento Anterior'
                      } else {
                        return tooltipItem[0].xLabel + ' - Faturamento Atual'
                      }
                    },
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingFaturamentoRedesRS = false })

        eventEmit.$emit('enable-btn-print', true)
      },

      handleBtnPrint () {
        this.enableBtnPrint = true
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Definir a margem esquerda
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16
          let posYFiltros = 10

          const title = 'Análise Redes'
          pdf.text(title, 105, posYFiltros)

          posYFiltros += 10
          const filtros = 'Filtros Selecionados:'
          pdf.setFontSize(10)
          pdf.text(filtros, 15, posYFiltros)

          const datas = this.mes[0].texto + ' - ' + this.ano
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisores.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

          // Adicionar a imagem dos filtros usando html2canvas
          const bloco1 = document.getElementById('bloco1Print')
          const canvasBloco1Print = await html2canvas(bloco1)
          const imgWidthBloco1 = 290
          const imgHeightBloco1 = (canvasBloco1Print.height * imgWidthBloco1) / canvasBloco1Print.width

          pdf.addImage(canvasBloco1Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco1, imgHeightBloco1)

          posYFiltros += imgHeightBloco1

          pdf.addPage()
          posYFiltros = 10

          const bloco2 = document.getElementById('bloco2Print')
          const canvasBloco2Print = await html2canvas(bloco2)
          const imgWidthBloco2 = 290
          const imgHeightBloco2 = (canvasBloco2Print.height * imgWidthBloco2) / canvasBloco2Print.width

          pdf.addImage(canvasBloco2Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco2, imgHeightBloco2)

          pdf.save('relatorio_analise_redes.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.faturamentoGrupoProdutosPrint = []
          this.faturamentoLinhaPrint = []
          this.headersTableLinha = []
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #iconInformationFaturamentoPorRede {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationQuantidadeKG {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationFaturamentoRS {
      margin: -6.8rem 0 0 0;
    }
  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }
</style>

<style lang="sass">
  #textoAnaliseFaturamento
    font-size: 36px
    margin: 1.5rem 0 0 0

  #textoFaturamento
    margin: 0 0 0 -2rem

  #btnPrint
    margin: 0.5rem 0 2rem 3rem

  .hidden
    display: none

  #iconInformationFaturamento
    margin: -6.5rem 0 0 15rem
</style>
